import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Tooltip from '@mui/material/Tooltip'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { useTranslation } from 'react-i18next'

interface IVisibilityCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
}

/**
 * Renders a visibility checkbox component.
 *
 * @param {boolean} checked - Indicates whether the checkbox is checked or not.
 * @param {function} onChange - Callback function that is called when the checkbox value changes.
 * @return {React.ReactElement} The rendered visibility checkbox component.
 * @notExported
 */
const VisibilityCheckbox: React.FC<IVisibilityCheckboxProps> = ({ checked, onChange }) => {
  const { t } = useTranslation()
  const title = checked ? t('print.visibilityOff') : t('print.visibilityOn')

  return (
    <FormControlLabel
      onClick={event => event.stopPropagation()}
      onFocus={event => event.stopPropagation()}
      style={{ marginLeft: 5 }}
      label=""
      control={
        <Tooltip title={title}>
          <Checkbox
            color="primary"
            icon={<VisibilityIcon />}
            checkedIcon={<VisibilityOffIcon />}
            slotProps={{
              input: {
                'aria-label': title,
              },
            }}
            checked={checked}
            onChange={event => {
              onChange(event.target.checked)
            }}
          />
        </Tooltip>
      }
    />
  )
}

export default VisibilityCheckbox
